<template>
  <div>
    <v-snackbar v-model="snackbar" :top="true" :color="color" :timeout="6000">
      <span v-if="snackbar_msg != null">{{ snackbar_msg }}</span>
      <v-btn dark text @click="snackbar = false">Close</v-btn>
    </v-snackbar>
    <sbpps-lc v-if="tenant == 'sbpps'" />
    <zeal-lc v-else-if="tenant == 'zeal'" />
    <veis-lc v-else-if="tenant == 'veis'" />
    <wws-lc v-else-if="tenant == 'wws'" />
    <vvp-lc v-else-if="tenant == 'vvp'" />
    <eps-lc v-else-if="tenant == 'eps'" />
    <sanjivani-lc v-else-if="tenant == 'sanjivani'" />
    <tmv-lc v-else-if="tenant == 'tmvidyalaya'" />
    <get-lc-template v-else-if="tenant == 'desschool' || tenant == 'mkd' || tenant == 'savpm'" />
    <des-lc v-else-if="tenant == 'desschool'" />

    <div v-else>Under Development.....</div>
  </div>
</template>

<script>
import axios from "axios";
import zeallc from "./GetLeavingCertZeal.vue";
import sbppslc from "./GetLeavingCertSbpps.vue";
import veislc from "./GetLeavingCertVEIS.vue";
import wwslc from "./GetLeavingCertWWS.vue";
import vvplc from "./GetLeavingCertVVP.vue";
import epslc from "./GetLeavingCertEPS.vue";
import sanjivanilc from "./GetLeavingCertSanjivani.vue";
import tmvlc from "./GetLeavingCertTMV.vue";
import deslc from "./GetLeavingCertDES.vue";
import getlctemplate from "./GetLeavingCertTemplate.vue";

export default {
  components: {
    "zeal-lc": zeallc,
    "sbpps-lc": sbppslc,
    "veis-lc": veislc,
    "wws-lc": wwslc,
    "vvp-lc": vvplc,
    "eps-lc": epslc,
    "sanjivani-lc":sanjivanilc,
    "tmv-lc":tmvlc,
    "des-lc":deslc,
    "get-lc-template":getlctemplate,
  },
  data: () => ({
    tenant: null,
    isTemplateBased: false,
    snackbar_msg: "",
    color: "",
    snackbar: false,
  }),
  methods: {
      fetchLCType() {
          axios.post("/certificate/fetchLCType")
          .then((res) => {
              if (res.data.flag === "YES") {
                  this.isTemplateBased = res.data.isTemplateBased
              }
          })
          .catch(() => {
              this.showSnackbar("error","Error in loading LC Type")
          })
          .finally(() => {
          });
      },
      showSnackbar(clr, msg) {
        this.snackbar = true;
        this.color = clr;
        this.snackbar_msg = msg;
      },
    },
  created() {
    this.tenant = localStorage.getItem("EPS-tenant");
    console.log("tenant:",this.tenant)
  },
  mounted() {
    this.fetchLCType();
  }
};
</script>

<style>
</style>